import React, { useEffect, useRef, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  Button,
  TextField,
  Divider,
  useMediaQuery,
  Drawer,
  IconButton,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import locationIcon from "../../assets/locationIconHome.png";
import StarIcon from "@mui/icons-material/Star";
import StarOutlineIcon from "@mui/icons-material/StarOutline";
import SalonImage from "../../assets/salonImage2.png";
import SearchIcon from "@mui/icons-material/Search";
import { useDispatch, useSelector } from "react-redux";
import { getAllServices } from "./servicesListApi";
import MediaModel from "../../common/mediaModel";
import { routePath } from "../../constants/routePath";
import { useLocation, useNavigate } from "react-router";
import ApModal from "../../common/AppoinmetModalppBtn";
import { getSession, setSession } from "../../utils/commonUtils";
import ProfileModal from "./profileModal";
import { setDetail, setNavBarInputFields } from "../../app/store/reducer";
import Footer from "../../common/Footer";
import SEO from "../../common/SEO";
import SortIcon from "@mui/icons-material/FilterList";

import MenuIcon from "@mui/icons-material/Menu";
const ServicesList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [serViceList, setServiceList] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedGender, setSelectedGender] = useState([]);
  const [selectedServiceAt, setSelectedServiceAt] = useState([]);

  const [open, setOpen] = useState(false);
  const [openT, setOpenT] = useState(false);
  const [modelData, setModelData] = useState({});
  const [hide, setHide] = useState(false);

  const infoD = useSelector((state) => state.reducer.detail);
  const navBarInputFields = useSelector(
    (state) => state.reducer.navBarInputFields,
  );
  const userDetail = useSelector((state) => state.reducer.userDetail);
  const location = useLocation();
  const hasAppliedCategoryFromState = useRef(false);

  useEffect(() => {
    const savedLocation = sessionStorage.getItem("location");
    if (savedLocation) {
      dispatch(setNavBarInputFields({ location: savedLocation }));
    }
    dispatch(setDetail(""));
  }, []);

  useEffect(() => {
    const categoryFromNav = location.state?.selectedCategory;

    if (categoryFromNav && !hasAppliedCategoryFromState.current) {
      // Mark as applied so it doesn’t run again
      hasAppliedCategoryFromState.current = true;

      // Reset filters
      setSelectedCategory([categoryFromNav]);
      setSelectedGender([]);
      setSelectedServiceAt([]);
      window.scrollTo({ top: 0, behavior: "smooth" });

      // ✅ Delay fetch slightly until Redux data is ready
      setTimeout(() => {
        fetchServices([categoryFromNav], [], []);
        navigate(location.pathname, { replace: true });
      }, 400);
    }
  }, [location.state, infoD, navBarInputFields]);

  // useEffect(() => {
  //   const categoryFromNav = location.state?.selectedCategory;

  //   if (categoryFromNav) {
  //     setSelectedCategory([categoryFromNav]);
  //     setSelectedGender([]); \
  //     setSelectedServiceAt([]);
  //   }
  // }, [location.state?.selectedCategory]);

  // Above is when selected Category is passed from nav bar search
  // And below is it is called once & refresh the state
  // useEffect(() => {
  //   const categoryFromNav = location.state?.selectedCategory;

  //   if (categoryFromNav) {
  //     setSelectedCategory([categoryFromNav]);
  //     setSelectedGender([]);
  //     setSelectedServiceAt([]);

  //     // Clear state so it doesn’t reapply on refresh
  //     // navigate(location.pathname, { replace: true });
  //   }
  // }, []);

  // useEffect(() => {
  //   const categoryFromNav = location.state?.selectedCategory;
  //   if (categoryFromNav && !hasSetCategoryFromNav.current) {
  //     setSelectedCategory([categoryFromNav]);
  //     hasSetCategoryFromNav.current = true;
  //   }
  // }, [location.state?.selectedCategory]);

  // useEffect(() => {
  //   const categoryFromNav = location.state?.selectedCategory;
  //   if (categoryFromNav) {
  //     setSelectedCategory([categoryFromNav]); // 👈 set filter state
  //   }
  // }, [location.state?.selectedCategory]);

  const categories = [
    "Salon",
    "Men’s Parlour",
    "Beauty Parlour",
    "Unisex Parlour",
    "Massage Center",
    "Wellness Center",
    "Tatto Art Artist",
    "Mehandi Artist",
    "Skin Care Studio",
    "Panchakarma",
    "Makeup & Hairstyle Artist",
    "Nail Art",
  ];

  const genderOptions = ["Men’s Parlour", "Ladies Parlour", "Unisex Parlour"];
  const serviceAtOptions = ["Parlour", "Home"];

  const toggleSelection = (item, selectedList, setSelectedList) => {
    if (selectedList.includes(item)) {
      setSelectedList(selectedList.filter((i) => i !== item));
    } else {
      setSelectedList([...selectedList, item]);
    }
  };
  // const getSearchBusiness = async () => {
  //   getAllServices(
  //     {
  //       billerId: infoD?.billerId || 0,
  //       area: navBarInputFields.location || "",
  //       search: navBarInputFields.bussiness || "",
  //       search1: selectedCategory.map((c) => ({ value: c })),
  //       search2: selectedGender.map((g) => ({ value: g })),
  //       search3: selectedServiceAt.map((s) => ({ value: s })),
  //     },
  //     (data) => {
  //       setServiceList(data);
  //     }
  //   );
  // };
  // ✅ Unified fetch function
  const fetchServices = (
    category = selectedCategory,
    gender = selectedGender,
    serviceAt = selectedServiceAt,
  ) => {
    getAllServices(
      {
        billerId: infoD?.billerId || 0,
        area: navBarInputFields.location || "",
        search: navBarInputFields.bussiness || "",
        search1: category.map((c) => ({ value: c })),
        search2: gender.map((g) => ({ value: g })),
        search3: serviceAt.map((s) => ({ value: s })),
      },
      (data) => setServiceList(data),
    );
  };

  // useEffect(() => {
  //   getSearchBusiness();
  // }, []);

  // useEffect(() => {
  //   getSearchBusiness();
  // }, [navBarInputFields, selectedCategory, selectedGender, selectedServiceAt]);
  useEffect(() => {
    // When opening page normally (no state)
    if (
      !hasAppliedCategoryFromState.current &&
      !location.state?.selectedCategory
    ) {
      fetchServices(); // fetch all data once on load
      hasAppliedCategoryFromState.current = true;
    } else {
      // After that, handle all filter changes
      fetchServices();
    }
  }, [navBarInputFields, selectedCategory, selectedGender, selectedServiceAt]);
  const routeOnAppoinment = async () => {
    await setSession("nextPage", "APPOINMENT");
    if (!userDetail || Object.keys(userDetail).length === 0) {
      navigate(routePath.LOGIN);
    } else {
      navigate(routePath.APPOINMENT);
    }
  };
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  return (
    <>
      <SEO
        title="Elegant Prime"
        description="All in One Basic Software for billing, inventory, and business management. Perfect solution for small and medium businesses."
        keywords="All-in-One Salon Management Software – POS, CRM & Billing, Salon & Spa Software – streamline operations, retain clients, boost revenue, Billing & Inventory Management Software for salons, Appointment Scheduling App for salons & spas,
Salon CRM Software India – customer retention made easy, Online Salon Booking System for clients, Loyalty Program Features to reward & retain customers, Staff Scheduling Software – manage beauticians & salon staff with ease,
Beauty Parlour Software with GST Billing – fast, compliant billing, Cloud-based Salon Management System – access anywhere, anytime
Salon Marketplace Integration – sell beauty products & services online, Best salon management app for parlours,
Best appointment scheduling app for salons, Affordable salon management software India, Mobile app for salon business growth,
Beauty parlour software India, Salon billing software with GST, Best salon management app, Salon staff scheduling software"
        canonical="https://elegantprime.in/ServicesList"
        schema={{
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          name: "All in One Basic Software",
          applicationCategory: "BusinessApplication",
          operatingSystem: "Web, Windows, Mac",
        }}
      />
      <Box sx={{ fontFamily: "'Montserrat', sans-serif", minHeight: "100vh" }}>
        {isMobile && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              mb: { xs: 0, sm: 2 },
              px: 2,
            }}
          >
            <IconButton onClick={() => setMobileSidebarOpen(true)}>
              <SortIcon
                sx={{
                  fontSize: "32px", // custom pixel size
                  cursor: "pointer",
                  color: "#000", // optional
                }}
              />
            </IconButton>
          </Box>
        )}
        <Grid container spacing={{ xs: 0, sm: 2 }} py={{ sm: 2, xs: 0 }}>
          {/* Sidebar */}

          {/* Desktop View */}
          {!isMobile && (
            <Grid item xs={6} sm={3}>
              <Box
                sx={{
                  background: "white",
                  padding: "15px",
                  borderRadius: "10px",
                  boxShadow: "0px 4px 4px 0px #00000040",
                  fontFamily: "'Montserrat', sans-serif",
                }}
              >
                {/* Search Box */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    border: "1px solid #01008B",
                    borderRadius: "15px",
                    overflow: "hidden",
                  }}
                >
                  <TextField
                    placeholder="Search Services / Product..."
                    fullWidth
                    sx={{
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      backgroundColor: "#fff",
                      "& .MuiInputBase-input": {
                        padding: "7.5px 10px !important",
                        fontFamily: "Kanit",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": { border: "none" },
                        "&:hover fieldset": { border: "none" },
                        "&.Mui-focused fieldset": { border: "none" },
                      },
                      "& .MuiInputBase-input::placeholder": {
                        color: "#585858",
                        opacity: 1,
                      },
                    }}
                    value={navBarInputFields.bussiness}
                    onChange={(e) =>
                      dispatch(
                        setNavBarInputFields({ bussiness: e.target.value }),
                      )
                    }
                  />
                  <Button
                    variant="contained"
                    sx={{
                      borderRadius: "0 14px 14px 0",
                      padding: "8px 16px",
                    }}
                  >
                    <SearchIcon
                      onClick={() => {
                        if (navBarInputFields.bussiness?.trim() !== "") {
                          navigate(routePath.SERVICESLIST);
                        }
                      }}
                    />
                  </Button>
                </Box>

                <Divider sx={{ backgroundColor: "#01008B", my: 2 }} />

                {/* Category */}
                <Typography sx={{ fontSize: "16px", fontWeight: 600 }}>
                  Categories
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                    mt: 1,
                    justifyContent: "center",
                  }}
                >
                  {categories.map((category, idx) => (
                    <Typography
                      key={idx}
                      onClick={() =>
                        toggleSelection(
                          category,
                          selectedCategory,
                          setSelectedCategory,
                        )
                      }
                      sx={{
                        padding: "6px 16px",
                        borderRadius: "15px",
                        fontWeight: 500,
                        fontSize: { xs: "10px", sm: "12px" },
                        backgroundColor: selectedCategory.includes(category)
                          ? "#CECEFF"
                          : "#fff",
                        color: selectedCategory.includes(category)
                          ? "primary.main"
                          : "black",
                        boxShadow: "0px 1px 8.4px 0px #00000040",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        minWidth: "130px",
                        textAlign: "center",
                      }}
                    >
                      {category}
                      {selectedCategory.includes(category) && (
                        <ClearIcon
                          sx={{ fontSize: "18px", ml: 1 }}
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleSelection(
                              category,
                              selectedCategory,
                              setSelectedCategory,
                            );
                          }}
                        />
                      )}
                    </Typography>
                  ))}
                </Box>

                {/* Gender */}
                <Typography sx={{ fontSize: "16px", fontWeight: 600, mt: 2 }}>
                  Gender
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                    mt: 1,
                    justifyContent: "center",
                  }}
                >
                  {genderOptions.map((option, idx) => (
                    <Typography
                      key={idx}
                      onClick={() =>
                        toggleSelection(
                          option,
                          selectedGender,
                          setSelectedGender,
                        )
                      }
                      sx={{
                        padding: "6px 16px",
                        borderRadius: "15px",
                        fontWeight: 500,
                        fontSize: "12px",
                        backgroundColor: selectedGender.includes(option)
                          ? "#CECEFF"
                          : "#fff",
                        // color: selectedGender === option ? "primary.main" : "black",
                        color: selectedGender.includes(option)
                          ? "primary.main"
                          : "black",
                        boxShadow: "0px 1px 8.4px 0px #00000040",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        minWidth: "130px",
                        textAlign: "center",
                      }}
                    >
                      {option}
                      {selectedGender.includes(option) && (
                        <ClearIcon
                          sx={{ fontSize: "18px", ml: 1 }}
                          // onClick={(e) => {
                          //   e.stopPropagation();
                          //   setSelectedGender("");
                          // }}
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleSelection(
                              option,
                              selectedGender,
                              setSelectedGender,
                            );
                          }}
                        />
                      )}
                    </Typography>
                  ))}
                </Box>

                {/* Service At */}
                <Typography sx={{ fontSize: "16px", fontWeight: 600, mt: 2 }}>
                  Service At
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                    mt: 1,
                    justifyContent: "center",
                  }}
                >
                  {serviceAtOptions.map((option, idx) => (
                    <Typography
                      key={idx}
                      onClick={() =>
                        toggleSelection(
                          option,
                          selectedServiceAt,
                          setSelectedServiceAt,
                        )
                      }
                      sx={{
                        padding: "6px 16px",
                        borderRadius: "15px",
                        fontWeight: 500,
                        fontSize: "12px",
                        backgroundColor: selectedServiceAt.includes(option)
                          ? "#CECEFF"
                          : "#fff",
                        // color:
                        //   selectedServiceAt === option ? "primary.main" : "black",
                        color: selectedServiceAt.includes(option)
                          ? "primary.main"
                          : "black",
                        boxShadow: "0px 1px 8.4px 0px #00000040",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        minWidth: "130px",
                        textAlign: "center",
                      }}
                    >
                      {option}
                      {selectedServiceAt.includes(option) && (
                        <ClearIcon
                          sx={{ fontSize: "18px", ml: 1 }}
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleSelection(
                              option,
                              selectedServiceAt,
                              setSelectedServiceAt,
                            );
                          }}
                        />
                      )}
                    </Typography>
                  ))}
                </Box>
              </Box>
            </Grid>
          )}

          {/* MObile Drawwer sidebar */}
          <Drawer
            anchor="left"
            open={mobileSidebarOpen}
            onClose={() => setMobileSidebarOpen(false)}
            PaperProps={{
              sx: {
                width: "80%",
                padding: "16px",
                boxSizing: "border-box",
              },
            }}
          >
            {/* You can add a close button at the top if you want */}
            <Box
              onClick={() => setMobileSidebarOpen(false)}
              sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}
            >
              <IconButton>
                <ClearIcon />
              </IconButton>
            </Box>
            {/* ..... */}

            <Grid item xs={12} sm={3}>
              <Box
                sx={{
                  background: "white",
                  padding: "15px",
                  borderRadius: "10px",
                  boxShadow: "0px 4px 4px 0px #00000040",
                  fontFamily: "'Montserrat', sans-serif",
                }}
              >
                {/* Search Box */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    border: "1px solid #01008B",
                    borderRadius: "15px",
                    overflow: "hidden",
                  }}
                >
                  <TextField
                    placeholder="Search Services / Product..."
                    fullWidth
                    sx={{
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      backgroundColor: "#fff",
                      "& .MuiInputBase-input": {
                        padding: "7.5px 10px !important",
                        fontFamily: "Kanit",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": { border: "none" },
                        "&:hover fieldset": { border: "none" },
                        "&.Mui-focused fieldset": { border: "none" },
                      },
                      "& .MuiInputBase-input::placeholder": {
                        color: "#585858",
                        opacity: 1,
                      },
                    }}
                    value={navBarInputFields.bussiness}
                    onChange={(e) =>
                      dispatch(
                        setNavBarInputFields({ bussiness: e.target.value }),
                      )
                    }
                  />
                  <Button
                    variant="contained"
                    sx={{
                      borderRadius: "0 14px 14px 0",
                      padding: "8px 16px",
                    }}
                  >
                    <SearchIcon
                      onClick={() => {
                        if (navBarInputFields.bussiness?.trim() !== "") {
                          navigate(routePath.SERVICESLIST);
                        }
                      }}
                    />
                  </Button>
                </Box>

                <Divider sx={{ backgroundColor: "#01008B", my: 2 }} />

                {/* Category */}
                <Typography sx={{ fontSize: "16px", fontWeight: 600 }}>
                  Categories
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                    mt: 1,
                    justifyContent: "center",
                  }}
                >
                  {categories.map((category, idx) => (
                    <Typography
                      key={idx}
                      onClick={() =>
                        toggleSelection(
                          category,
                          selectedCategory,
                          setSelectedCategory,
                        )
                      }
                      sx={{
                        padding: "6px 16px",
                        borderRadius: "15px",
                        fontWeight: 500,
                        fontSize: { xs: "10px", sm: "12px" },
                        backgroundColor: selectedCategory.includes(category)
                          ? "#CECEFF"
                          : "#fff",
                        color: selectedCategory.includes(category)
                          ? "primary.main"
                          : "black",
                        boxShadow: "0px 1px 8.4px 0px #00000040",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        minWidth: "130px",
                        textAlign: "center",
                      }}
                    >
                      {category}
                      {selectedCategory.includes(category) && (
                        <ClearIcon
                          sx={{ fontSize: "18px", ml: 1 }}
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleSelection(
                              category,
                              selectedCategory,
                              setSelectedCategory,
                            );
                          }}
                        />
                      )}
                    </Typography>
                  ))}
                </Box>

                {/* Gender */}
                <Typography sx={{ fontSize: "16px", fontWeight: 600, mt: 2 }}>
                  Gender
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                    mt: 1,
                    justifyContent: "center",
                  }}
                >
                  {genderOptions.map((option, idx) => (
                    <Typography
                      key={idx}
                      onClick={() =>
                        toggleSelection(
                          option,
                          selectedGender,
                          setSelectedGender,
                        )
                      }
                      sx={{
                        padding: "6px 16px",
                        borderRadius: "15px",
                        fontWeight: 500,
                        fontSize: "12px",
                        backgroundColor: selectedGender.includes(option)
                          ? "#CECEFF"
                          : "#fff",
                        // color: selectedGender === option ? "primary.main" : "black",
                        color: selectedGender.includes(option)
                          ? "primary.main"
                          : "black",
                        boxShadow: "0px 1px 8.4px 0px #00000040",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        minWidth: "130px",
                        textAlign: "center",
                      }}
                    >
                      {option}
                      {selectedGender.includes(option) && (
                        <ClearIcon
                          sx={{ fontSize: "18px", ml: 1 }}
                          // onClick={(e) => {
                          //   e.stopPropagation();
                          //   setSelectedGender("");
                          // }}
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleSelection(
                              option,
                              selectedGender,
                              setSelectedGender,
                            );
                          }}
                        />
                      )}
                    </Typography>
                  ))}
                </Box>

                {/* Service At */}
                <Typography sx={{ fontSize: "16px", fontWeight: 600, mt: 2 }}>
                  Service At
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                    mt: 1,
                    justifyContent: "center",
                  }}
                >
                  {serviceAtOptions.map((option, idx) => (
                    <Typography
                      key={idx}
                      onClick={() =>
                        toggleSelection(
                          option,
                          selectedServiceAt,
                          setSelectedServiceAt,
                        )
                      }
                      sx={{
                        padding: "6px 16px",
                        borderRadius: "15px",
                        fontWeight: 500,
                        fontSize: "12px",
                        backgroundColor: selectedServiceAt.includes(option)
                          ? "#CECEFF"
                          : "#fff",
                        // color:
                        //   selectedServiceAt === option ? "primary.main" : "black",
                        color: selectedServiceAt.includes(option)
                          ? "primary.main"
                          : "black",
                        boxShadow: "0px 1px 8.4px 0px #00000040",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        minWidth: "130px",
                        textAlign: "center",
                      }}
                    >
                      {option}
                      {selectedServiceAt.includes(option) && (
                        <ClearIcon
                          sx={{ fontSize: "18px", ml: 1 }}
                          onClick={(e) => {
                            e.stopPropagation();
                            toggleSelection(
                              option,
                              selectedServiceAt,
                              setSelectedServiceAt,
                            );
                          }}
                        />
                      )}
                    </Typography>
                  ))}
                </Box>
              </Box>
            </Grid>
          </Drawer>
          {/* Right Panel: Service List */}
          <Grid
            item
            xs={12}
            sm={9}
            // pl={{ xs: 10, sm: 0 }}
            px={{ xs: 2, sm: 3 }}
          >
            <MediaModel open={open} setOpen={setOpen} modelData={modelData} />
            <ProfileModal
              open={openT}
              setOpen={setOpenT}
              modelData={modelData}
            />

            <Box sx={{ pt: 3 }}>
              <Grid container spacing={4}>
                {serViceList.map((item, index) => {
                  const stars = Array.from({ length: 5 }, (_, i) =>
                    i < item.averageRating ? (
                      <StarIcon
                        key={i}
                        sx={{ color: "#ff5e00", fontSize: "18px" }}
                      />
                    ) : (
                      <StarOutlineIcon
                        key={i}
                        sx={{ color: "#ff5e00", fontSize: "18px" }}
                      />
                    ),
                  );

                  return (
                    <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                      <Card
                        onClick={() => {
                          dispatch(setDetail(item));
                          navigate(routePath.SALON);
                        }}
                        sx={{
                          padding: "10px",
                          boxShadow: "0px 6px 20.1px -1px #00000040",
                          borderRadius: "8px",
                          height: "100%",
                          cursor: "pointer",
                        }}
                      >
                        <CardContent sx={{ padding: "0 !important" }}>
                          <img
                            src={SalonImage}
                            alt="Salon"
                            style={{ width: "100%" }}
                          />
                          <Box sx={{ py: 1 }}>
                            <Typography fontWeight={600} fontSize="17px">
                              {item.enterpriseName}
                              <Typography
                                component="span"
                                fontSize="12px"
                                ml={1}
                              >
                                (B.Id - {item.billerId ?? "N/A"})
                              </Typography>
                            </Typography>
                            <Typography fontSize="13px">
                              {item.serviceTo}
                            </Typography>
                            <Typography fontSize="13px">
                              Service At:{" "}
                              {item.serviceFrom === "Home service"
                                ? "Home & Salon"
                                : "Salon"}
                            </Typography>
                            <Typography
                              fontSize="13px"
                              display="flex"
                              alignItems="center"
                            >
                              <img
                                src={locationIcon}
                                alt="Location"
                                style={{ width: "15px", marginRight: "4px" }}
                              />
                              {item.area}
                            </Typography>
                            <Typography
                              fontSize="10px"
                              display="flex"
                              flexDirection={{ xs: "column", sm: "row" }}
                              alignItems="center"
                            >
                              <Typography
                                fontSize="10px"
                                display="flex"
                                // flexDirection={{xs:"column", sm:"row"}}
                                alignItems="center"
                              >
                                {stars}
                              </Typography>
                              <Typography
                                component="span"
                                fontSize="13px"
                                ml={1}
                              >
                                {item.averageRating} ({item.totalRating}{" "}
                                {item.totalRating === 1 ? "Review" : "Reviews"})
                              </Typography>
                            </Typography>
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>
                  );
                })}
              </Grid>
            </Box>
          </Grid>
        </Grid>
        <ApModal open={hide} setOpen={setHide} />
        <Box sx={{ pt: 10 }}>
          <Footer />
        </Box>
      </Box>
    </>
  );
};

export default ServicesList;
